export enum CompetitorsApi {
  GetCompetitors = '/competitors/',
  AddCompetitor = '/competitors',
  UpdateCompetitor = '/competitors/:id',
  DeleteCompetitor = '/competitors/:id',
  GetCompetitor = '/competitors/:id'
}
